export class MemoStatusView
{
  public memoStatusId: number;
  public status: string;
  // Variables de apoyo.
  public sStatusComplete: string;
  public sStatusTranslation: string;
}
